import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

import { Account } from "../../API";

export enum PlayerMode {
  KIOSK = "KIOSK",
  DEFAULT = "DEFAULT",
}

export type PlayerState = {
  logged: boolean;
  username: string;
  email: string;
  account?: Account | null;
  groups?: Array<string>;
  mode: PlayerMode;
  displayName?: string;
  balance: number;
};

const initialState: PlayerState = {
  logged: false,
  username: "",
  email: "",
  account: null,
  groups: [],
  mode: PlayerMode.DEFAULT,
  displayName: null,
  balance: 0,
};

export const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    login: (state, action) => {
      state.logged = true;
      state.username = action.payload.username;
      state.email = action.payload.email;
      state.groups = action.payload.groups;
      state.mode =
        action.payload.groups.indexOf("kiosks") > -1
          ? PlayerMode.KIOSK
          : PlayerMode.DEFAULT;
      if (state.displayName) state.displayName = action.payload.displayName;
    },
    logout: (state) => {
      state.logged = false;
    },
    updateAccount: (state, action) => {
      state.account = action.payload;
    },
    setPlayerMode: (state, action: PayloadAction<PlayerMode>) => {
      state.mode = action.payload;
    },

    setDisplayName: (state, action) => {
      state.displayName = action.payload;
    },
    setBalance: (state, action) => {
      state.balance = action.payload;
    },
  },
});

export const {
  login,
  logout,
  updateAccount,
  setPlayerMode,
  setDisplayName,
  setBalance,
} = playerSlice.actions;

export const selectPlayer = (state: RootState) => state.player;

export default playerSlice.reducer;
